import React, { useState, useEffect, useMemo } from 'react'
import '../assets/styles/PharmaciesVendre.css'
import NavigationBtns from '../components/navigationBtns';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BsDownload } from 'react-icons/bs';

export default function PharmaciesVendre() {
  const [pharmacies, setPharmacies] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedGov, setSelectedGov] = useState('Tous');
  const navigate = useNavigate();

  const getPharmaciesOnSale = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/getPharmaciesOnSale`);
      setPharmacies(res.data);
    } catch (err) {
      console.error("Erreur lors du chargement des pharmacies :", err);
    }
  };

  useEffect(() => {
    const numConnexion = localStorage.getItem('U2FsdGVkX19xqKHwGY8nQLnQc8gwVyHkcrKpJBegXRg');
    if (!numConnexion) {
      navigate('/authRequired');
      return;
    }
    getPharmaciesOnSale();
  }, [navigate]);

  const gouvernorats = useMemo(() => {
    const all = pharmacies.map(p => p.Gouvernorat).filter(Boolean);
    return ['Tous', ...new Set(all)];
  }, [pharmacies]);

  const filteredPharmacies = useMemo(() => {
    return pharmacies.filter(pharma => {
      const matchSearch =
        pharma.NomPharmacie?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        pharma.Adresse?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        pharma.Gouvernorat?.toLowerCase().includes(searchTerm.toLowerCase());

      const matchGov = selectedGov === 'Tous' || pharma.Gouvernorat === selectedGov;

      return matchSearch && matchGov;
    });
  }, [pharmacies, searchTerm, selectedGov]);


  function openFile(attachment) {
    if (!attachment?.data?.data || !attachment?.extension) return;

    const byteArray = new Uint8Array(attachment.data.data);
    const mimeType = {
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    }[attachment.extension.toLowerCase()] || "application/octet-stream";

    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);

    window.open(url, "_blank");
  }


  return (
    <div className='Notifications-container'>
      <div className='inner-navbar'>
        <NavigationBtns />
      </div>
      <div className='Notifications-body'>

        <div className='Notifications-title-section'>
          <span className='Notifications-title'>À vendre</span>
          <span className='line'></span>
        </div>

        {/* ✅ Search & Filter Section */}
        {pharmacies.length > 0 && (
          <div className="filter-search-section">
            <input
              type="text"
              placeholder="Rechercher par nom, adresse ou gouvernorat..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <select
              value={selectedGov}
              onChange={(e) => setSelectedGov(e.target.value)}
              className="filter-dropdown"
            >
              {gouvernorats.map((gov, i) => (
                <option key={i} value={gov}>{gov}</option>
              ))}
            </select>
          </div>
        )}

        {/* ✅ Table Section */}
        <div className='Notifications-section'>
          {filteredPharmacies.length > 0 ? (
            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Nom de la pharmacie</th>
                    <th>Adresse</th>
                    <th>Gouvernorat</th>
                    <th>Prix</th>
                    <th>Contact</th>
                    <th>Fichier</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPharmacies.map((pharma) => (
                    <tr key={pharma.Id}>
                      <td data-label="Nom">{pharma.NomPharmacie}</td>
                      <td data-label="Adresse">{pharma.Adresse || '--'}</td>
                      <td data-label="Gouvernorat">{pharma.Gouvernorat || '--'}</td>
                      <td data-label="Prix">{pharma.sellingPrice ? `${pharma.sellingPrice} TND` : '--'}</td>
                      <td data-label="Contact">{pharma.sellerContact || '--'}</td>
                      <td data-label="Fichier">{pharma.attachementId ? <button onClick={() => { openFile(pharma.Attachement) }} style={{ border: "none", backgroundColor: 'transparent' }}>
                        <BsDownload />
                      </button> : '--'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div
              style={{
                flex: 5,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#00B16A',
                fontWeight: 500,
                marginTop: '10%',
              }}
            >
              <span>Aucune pharmacie trouvée.</span>
            </div>
          )}
        </div>

      </div>
    </div >
  )
}
